export type ListCacheEntry = {
  items: any[];
  cursor: number; // page number (Task) atau offset (Notification, MarketingActivity, dll)
  hasMore: boolean;
  scrollTop: number;
  needsRefresh?: boolean; // jika true: tampilkan stale items dulu, lalu refresh background
  meta?: Record<string, any>; // data tambahan per list, misal statusFilter
};

const _cache = new Map<string, ListCacheEntry>();

export const listCache = {
  save:      (key: string, data: ListCacheEntry) => _cache.set(key, data),
  restore:   (key: string): ListCacheEntry | null => _cache.get(key) ?? null,
  clear:     (key: string) => _cache.delete(key),
  // Tandai entry sebagai perlu refresh tanpa menghapus scrollTop/items
  invalidate: (key: string) => {
    const entry = _cache.get(key);
    if (entry) _cache.set(key, { ...entry, needsRefresh: true });
  },
  // Update satu item dalam cache tanpa menyimpan ulang seluruh list
  updateItem: (key: string, predicate: (item: any) => boolean, updater: (item: any) => any) => {
    const entry = _cache.get(key);
    if (!entry) return;
    _cache.set(key, { ...entry, items: entry.items.map(item => predicate(item) ? updater(item) : item) });
  },
  // Hapus semua cache — dipanggil saat logout agar cache user lama tidak bocor ke user berikutnya
  clearAll: () => _cache.clear(),
};
